'use strict';

// Translations controller
angular.module('orders').controller('ListOrdersController', [
	'$scope',
	'TranslationOrder',
	'TranslationOrderConstants',
	'Utilities',
	'Authentication',
	'TeamMembers',
	'$state',
	function(
		$scope,
		TranslationOrder,
		TranslationOrderConstants,
		Utilities,
		Authentication,
		TeamMembers,
		$state
	) {

		$scope.mobileApp = null;
		$scope.authentication = Authentication;
		$scope.roleInApp = 'none';

		$scope.orders = [];
		$scope.TranslationOrderConstants = TranslationOrderConstants;
		$scope.loadingInProgress = true;
		
		$scope.filteredOrders = [];
		$scope.displayOrdersFiltered = [];
		$scope.ordersListFilterValue = 'All';
		$scope.filteringOrderStates = {
			Closed: 'Closed',
			Open: 'Open',
			Active: 'Active'
		};
		$scope.allOrderStates = {
			draft:'draft',
			created:'created',		
			processing:'processing',	
			done:'done',
			requested:'requested',	
			declined:'declined',		
			accepted:'accepted',
			canceled: 'canceled'
		};

		$scope.goToOrder = function($event, order) {
			if(order.status === $scope.allOrderStates.canceled) return;

			if ($event.metaKey || $event.shiftKey || $event.ctrlKey || 
				$event.which === 2 || $event.button === 2) {
				$event.preventDefault();
				var url = $state.href('translationOrderView', {
					mobileAppId: $scope.mobileAppId,
					orderId: order._id 
				}, { absolute: true });
				window.open(url, '_blank');
			} else {
				$state.go('translationOrderView', { 
					mobileAppId: order.mobileApp._id, 
					orderId: order._id 
				});
			}
		};

		/**
		 * Filters orders list
		 */
		$scope.filterOrdersList = function(orderState){

			if(orderState){
				$scope.ordersListFilterValue = orderState;
			} else {
				$scope.ordersListFilterValue = 'All';
			}
			
			$scope.filteredOrders = $scope.orders.filter(function(order){
				switch (orderState) {
					case $scope.filteringOrderStates.Closed:
						return order.status === $scope.allOrderStates.done || order.status === $scope.allOrderStates.canceled;
					case $scope.filteringOrderStates.Open:
						return order.status !== $scope.allOrderStates.done && order.status !== $scope.allOrderStates.canceled; 
					case $scope.filteringOrderStates.Active:
						return order.status !== $scope.allOrderStates.done && order.status !== $scope.allOrderStates.canceled && order.status !== $scope.allOrderStates.draft;
					default:
						return order;
				}
			});
		};

		$scope.getfilteringOrderStates = function(){
			return Object.keys($scope.filteringOrderStates);
		};

		$scope.getCurrentRoleInApp = function (teamMembers) {
			var userId = $scope.authentication.user._id;

			if ($scope.authentication.user.username === 'superadmin' && $scope.authentication.user.email === 'superadmin@applanga.com') {
				$scope.roleInApp = 'superadmin';
			} else {
				for (var i = 0; i < teamMembers.length; i++) {
					if (userId === teamMembers[i].user._id) {
						$scope.roleInApp = teamMembers[i].role;
					}
				}
			}
		};

		$scope.filterOrdersBasedOnRole = function(){
			switch ($scope.roleInApp) {
				case 'superadmin':
				case 'tptadmin':
				case 'tptservices':
					$scope.filterOrdersList($scope.filteringOrderStates.Active);
					break;
				default:
					$scope.filterOrdersList($scope.filteringOrderStates.Open);
					break;
			}
		};

		function init() {
			TranslationOrder.getOrders({},
				function(response) {
					$scope.loadingInProgress = false;

					if(!response || !response.length){
						return;
					}

					$scope.mobileApp = response[response.length-1].mobileApp;
					TeamMembers.getAll({
						teamId: $scope.mobileApp.team
					}, function (teamMembers) {
						
						$scope.getCurrentRoleInApp(teamMembers);

						response.forEach(function(order) {
							if(order.targetLanguages){
								order.totalWordsCount = 0;
								Object.keys(order.targetLanguages).forEach(function(tl){
									order.totalWordsCount += order.targetLanguages[tl].words;
								});
							}
							
							$scope.orders.push(order);
						});
	
						$scope.filterOrdersBasedOnRole();
					});
				},
				function(error) {
					$scope.loadingInProgress = false;
					Utilities.showMessageErrorResponse(error);
				}
			);
		}

		init();

	}
]);
